export const HTML_NODE_VOID_TAGS = [
  "img",
  "br",
  "hr",
  "area",
  "base",
  "col",
  "embed",
  "input",
  "link",
  "meta",
  "source",
];

export const HTML_BLOCK_NODE_TAGS = [
  "div",
  "p",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "article",
  "aside",
  "nav",
  "section",
  "header",
  "footer",
  "address",
  "ul",
  "ol",
  "li",
  "table",
  "td",
  "th",
  "tr",
  "blockquote",
  "pre",
  "tbody",
  "center",
];
